import { makeStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';
import ExitToApp from '@mui/icons-material/ExitToApp';

const useStyles = makeStyles()((theme) => ({
  wrapper: {
    margin: theme.spacing(2, 0),
  },
  infoButton: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  infoIcon: {
    marginLeft: theme.spacing(0.5),
  },
}));

import type { Event } from '../../types/Event';

type Props = {
  event: Event;
};

const InfoUrlButton = ({ event }: Props) => {
  const { classes } = useStyles();

  if (!event.infoUrl) {
    return null;
  }

  const { infoUrl } = event;

  return (
    <div className={classes.wrapper}>
      <Button
        href={infoUrl}
        rel="noopener noreferrer"
        color="primary"
        variant="contained"
        className={classes.infoButton}
      >
        Learn More ({infoUrl.replace(/^https?:\/\//, '').replace(/\/.*$/, '')})
        <ExitToApp className={classes.infoIcon} />
      </Button>
    </div>
  );
};

export default InfoUrlButton;
